import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import * as shape from 'd3-shape';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { CierreService } from 'app/main/wizard-cgo/services/cierre.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
//SERVICE
import { CloseService } from "../services/cierre.service";
import { AlertDialogComponent } from 'app/main/pagina/certificar/alertdialog/alertdialog.component';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FormsModule,ReactiveFormsModule,FormControl } from "@angular/forms";
import { DATOS_API } from 'app/auth/auth.datos';
import {MatSnackBar} from '@angular/material/snack-bar';
interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;


};
@Component({
    selector     : 'cierre-dashboard',
    templateUrl  : './cierre.component.html',
    styleUrls    : ['./cierre.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class ProjectDashboardComponent implements OnInit
{   rutaPagina: string;
    claveConteos:string;
    cargando= true;
    porcentaje: number;
    url: string;
    projects: any[];
    selectedProject: any;
    flagCierre: boolean = false;
    showButtonInstitute: boolean = true;
    dialogRef: any;
    fechaActual= new Date();
    validadorFecha: boolean[] =[];
    vacio=true;
    idiomaActual:string;
    fechaLanzamientoR:any;
    claveConteosForaneo: boolean= false;

    // Datos certificar vigente

      productoPulse: backInter.prodPulseCheck;
      getProgressEncuesta: backInter.getProgressEncPulse;
      getFechas: backInter.getFechaPulse;
      clavesConteosPulse: backInter.clavesPulse[];
      sinClave:boolean=false;

      styleElement: HTMLStyleElement;

    //boolean paso completo
    pasoCompleto = false;

    widgets = {
        'tiempo'      : {
            'ranges'      : {
                'DT' : 'Today'
            },
            'currentRange': 'DT',
            'data'        : {
                'label': 'Dias restantes',
                'count': {
                    'DT' : 15
                },
                'extra': {
                    'label': 'Dias transcurridos',
                    'count': {
                        'DT' : 6
                    }
                }
            },
            'detail'      : '<h2>Más información</h2>Dia de lanzamiento de la encuesta:<br><b>01/09/2019</b><br><br>Día de cierre de la encuesta:<br><b>22/09/2019</b>'
        },
        'avance'      : {
            'ranges'      : {
                'DT' : 'Today'
            },
            'currentRange': 'DT',
            'data'        : {
                'label': 'Encuestas completas',
                'count': {
                    'DT' : '14%'
                },
                'extra': {
                    'label': 'Porcentaje restante',
                    'count': {
                        'DT' : '86%'
                    }
                }
            },
            'detail'      : '<h2>Más información</h2>Número de colaboradores encuestados: <b>343</b><br><br>Número de colaboradores con encuesta completa: <b>48</b><br><br>Número de colaboradores pendientes: <b>295</b>'
        }
    };

    dateNow = Date.now();
    diasRestantes:any;
    fechaCierre:any;
    constructor(
      public dialog: MatDialog,
      private cierreService: CierreService,
      private service : CloseService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private translateSrv: TranslateService,
      private wizardService: WizardService,
      private router: Router,
      private _snackBar: MatSnackBar,
    ){
        lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_cierre.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
        this.translateSrv.onLangChange.subscribe(() => {   this.idiomaActual = this.translateSrv.currentLang;});

        setInterval(() => {
            this.dateNow = Date.now();
        }, 1000);

        // this.getStatusCierre();

        if(localStorage.getItem('instituto') == '1'){
          this.showButtonInstitute = false;
        }else{
          this.showButtonInstitute = true;
        }

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
     ngOnInit() {
       this.styleElement = document.createElement('style');
         this.idiomaActual = this.translateSrv.currentLang;
         this.obtieneCertificarActual();
         this.cambiaColorProgress();

     }

     obtieneCertificarActual(){
       /// obtiene el producto certificar vigente
       this.cierreService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
         let prodsPulse:backInter.prodPulseCheck[] = data.productosPulseCheck;
         var BreakException = {};
         try {
           console.log('la fecha es :' + localStorage.getItem('fechaProducto'));
           console.log('el id producto es :' + localStorage.getItem('productoID'));
console.log('el producto pulse');
console.log(prodsPulse);

             prodsPulse.forEach( (producto) => {
               let fecha = producto.fechaPulseCheck;
               let idProducto = producto.idPulseCheck;
               if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
                 this.productoPulse= producto;
                 throw BreakException;
               }
             });
         } catch (e) {
             if (e !== BreakException) throw e;
         };
         //obtiene el status del paso adicionales del certificar vigente
         // this.cierreService.getStatusCierrePulse(this.productoPulse.idPulseCheck).subscribe( (data: backInter.getStatusIndiv) => {
         //   if(data.estatus === 3)
         //     this.pasoCompleto = true;
         // });

         this.getFecha();
         this.getStatusModal();
         //obtiene las preguntas adicionales guardadas
       }, error  => {
         console.log("error al recuperar certificar vigente");
       });
     }
     //
     getStatusModal(){
       let datos={
         productoId: this.productoPulse.idPulseCheck,
         close: 1
       };
       console.log(datos);
       this.wizardService.getStatusModalPulse(datos).subscribe( (data: backInter.getStatusModal) => {
         if(data.estatus==1){
               this.modalInformativo('CIERRE');
         }
       });
     }

     updateStatusModal(){
       let datos={
         productoId: this.productoPulse.idPulseCheck,
         close: 2
       };
       // console.log(datos);
       this.wizardService.updateStatusModalPulse(datos).subscribe( (data: any) => {
         // console.log(data);
       });
     }


     enviaOrdenWizard(){
       this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
     }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {

    }






  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO2';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      inputValidator: (result)=>{
        //alert(result);
        return new Promise((resolve)=>{
          if (result){
            this.updateStatusModal();
          }
          resolve(result);
        });
      },
      
      allowOutsideClick: false
    })
  }

  getprogress(){
    var moment =require('moment');
    console.log('este es el id' + this.productoPulse.idPulseCheck);
    this.cierreService.getProgressEncPulse(this.productoPulse.idPulseCheck).subscribe((resultado: any)=>{
      this.getClaveConteo();
    console.log(resultado);
      this.getProgressEncuesta=resultado;
      this.cargando= false;
      let fechaActual= moment();
      let fechaCierre= moment(this.fechaCierre);
      if(fechaActual.isAfter(fechaCierre)){
        this.diasRestantes=0;
        console.log(this.diasRestantes);

       }else{
        this.diasRestantes=fechaCierre.diff(fechaActual,'days');
        console.log(this.diasRestantes);
      }




    });
  }


  getFecha(){

    this.cierreService.getFechasProgramacionPulse(this.productoPulse.idPulseCheck).subscribe((respuesta: any)=>{

      this.fechaLanzamientoR=respuesta.data[0].fechaLanzamiento;
      this.fechaCierre=respuesta.data[0].fechaCierre;
      console.log(this.fechaLanzamientoR);

      this.getFechas=respuesta;
      this.getprogress()
     var moment =require('moment');
      console.log(respuesta);
      let iter= 0;
      this.getFechas.data.forEach( (fecha) => {

        let f1 = moment(fecha.fechaLanzamiento);
        let f2 = moment(this.fechaActual);

        if(f2 <= f1){
          this.validadorFecha.push(false);

          console.log("fecha despues");
        }
        else{
          this.validadorFecha.push(true);
          this.vacio=false;
          console.log("fecha antes");

        }

      });


    });
  }


      private navigateTo(ruta,encuestaID){
        localStorage.setItem('encuestaID', encuestaID);
        this.router.navigate([ruta]);


      }

      cambiaColorProgress() {
        const head = document.getElementsByTagName('head')[0];
        const css = `
        .prro .mat-progress-bar-fill::after {
          background-color: #28a745 !important;
        }`;
        this.styleElement.innerHTML = '';
        this.styleElement.type = 'text/css';
        this.styleElement.appendChild(document.createTextNode(css));
        head.appendChild(this.styleElement);

      }

      generarClave(numero: number){
        let datos:any ={empresaId: localStorage.getItem('companyID'),productoId:localStorage.getItem('productoID'),claveProducto: 4, idSurvey: this.getProgressEncuesta.data[numero].idSurvey};
        this.cierreService.saveConteosClaves(datos).subscribe( (data: backInter.getClaveConteos) => {
          this.claveConteos= data.clave._id;
          console.log(this.claveConteos);
          console.log(data);
          this.claveConteosForaneo=true;
          this.getClaveConteo();
        });
      }

      getClaveConteo(){
        let datos:any ={empresaId: localStorage.getItem('companyID'),productoId:localStorage.getItem('productoID')};
        console.log(datos);
        this.cierreService.getClavesConteosPulse(datos).subscribe( (data: backInter.getClaveConteosPulse) => {
          // this.claveConteos= data.clave._id;
          this.claveConteosForaneo=true;
          this.clavesConteosPulse= data.claves;
          if(this.clavesConteosPulse.length==0){
            this.sinClave=false;
          }else if(this.clavesConteosPulse.length!=0){
            this.sinClave=true;
          }
          console.log(data);
          console.log("tus claves son");
          console.log(this.clavesConteosPulse);

          console.log(this.claveConteos);
        });

}

copyMessage(val: string){
  let texto = 'CIERRE.CIERRE.COPYLINK';
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });

  // let url = DATOS_API.url.split(":");
  // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
  this.rutaPagina = DATOS_API.urlConteos + val;
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  // selBox.value=val;
  selBox.value=this.rutaPagina;
  console.log(this.rutaPagina);
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.openSnackBar(texto,"OK");
  /*Swal.fire({
    icon: 'success',
    title: texto,
    
  });*/

}
openSnackBar(message: string, action: string) {
  this._snackBar.open(message, action, {
    duration: 2000,
  });
}
auxCorreo_array:any;
banderaArreglo=0;
sendReminder(){
  console.log(this.fechaLanzamientoR);

  if(this.fechaLanzamientoR){

    var now = new Date();
    var date2 = new Date(now),
    mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
      day = ("0" + date2.getDate()).slice(-2);
    var timestamp1 = new Date(this.fechaLanzamientoR).getTime();
    var timestamp2 = new Date(date2).getTime();
    if(timestamp2>timestamp1){
      console.log("entro este visne");

      let datos:any ={productoId:localStorage.getItem('productoID')};
      this.cierreService. getRecordatoriosPulse(datos).subscribe( (data: any) => {
        console.log("Get recordatorios");
        console.log(data);
        this.auxCorreo_array=data.recordatoriosManuales;
        if (this.auxCorreo_array.length==0) {

          let datos:any={productoId:localStorage.getItem('productoID'), numeroFecha: 1}
          this.cierreService.sendRecordatoriosPulse(datos).subscribe( (data: any) => {
            console.log(data);
            console.log("se enviaron");


            let texto = 'CIERRE.LABEL5';
            this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
            this.openSnackBar(texto,"OK");
              /*Swal.fire({
                title: texto,
                icon: "success",
                confirmButtonColor: '#e40601'
              });*/

            });


        }else{
        var pos= this.auxCorreo_array.length;
        var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
        var timestampRecordatorio2 = new Date(date2).getTime();
        var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
        console.log(tiempoRecordatorios);
        if(timestamp1){
          if(tiempoRecordatorios >= 86400000){
            let datos:any={productoId:localStorage.getItem('productoID'), numeroFecha: 1}
            this.cierreService.sendRecordatoriosPulse(datos).subscribe( (data: any) => {
              console.log(data);
              console.log("se enviaron");


              let texto = 'CIERRE.LABEL5';
              this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
              this.openSnackBar(texto,"OK");
                /*Swal.fire({
                  title: texto,
                  icon: "success",
                  confirmButtonColor: '#e40601'
                });*/

              });

           }else{
            let texto = 'CIERRE.LABEL6';
            this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
            Swal.fire({
              title: texto,
              icon: "error",
              confirmButtonColor: '#e40601'
            });

           }

        }
}



      });

    }else{
      let texto = 'CIERRE.LABEL7';
       this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
       Swal.close();
          Swal.fire({
          title: texto,
          icon: "error",
          confirmButtonColor: '#e40601'
       });

    }

  }
}


}
